/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeurekaHostNameApiKeyData } from './HeurekaHostNameApiKeyData';
import {
    HeurekaHostNameApiKeyDataFromJSON,
    HeurekaHostNameApiKeyDataFromJSONTyped,
    HeurekaHostNameApiKeyDataToJSON,
    HeurekaHostNameApiKeyDataToJSONTyped,
} from './HeurekaHostNameApiKeyData';

/**
 * 
 * @export
 * @interface HeurekaIntegrationInput
 */
export interface HeurekaIntegrationInput {
    /**
     * 
     * @type {Array<HeurekaHostNameApiKeyData>}
     * @memberof HeurekaIntegrationInput
     */
    hostNameAndApiKeyList?: Array<HeurekaHostNameApiKeyData>;
}

/**
 * Check if a given object implements the HeurekaIntegrationInput interface.
 */
export function instanceOfHeurekaIntegrationInput(value: object): value is HeurekaIntegrationInput {
    return true;
}

export function HeurekaIntegrationInputFromJSON(json: any): HeurekaIntegrationInput {
    return HeurekaIntegrationInputFromJSONTyped(json, false);
}

export function HeurekaIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameAndApiKeyList': json['hostNameAndApiKeyList'] == null ? undefined : ((json['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameApiKeyDataFromJSON)),
    };
}

export function HeurekaIntegrationInputToJSON(json: any): HeurekaIntegrationInput {
    return HeurekaIntegrationInputToJSONTyped(json, false);
}

export function HeurekaIntegrationInputToJSONTyped(value?: HeurekaIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameAndApiKeyList': value['hostNameAndApiKeyList'] == null ? undefined : ((value['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameApiKeyDataToJSON)),
    };
}

